import { LinearGradient } from "expo-linear-gradient";
import React, { useEffect, useState } from 'react';
import { Image, Text, TextInput, TouchableOpacity, View } from 'react-native';
import { Checkbox } from 'react-native-paper';

import HeaderDefault from '../../components/HeaderDefault';

import styles from "./styles";
import { FormattedMessage } from "react-intl";

const BuyExchange = ({ navigation, route }) => {
    const [checked, setChecked] = useState(false);
    const [qtd, setQtd] = useState();
    const [token, setToken] = useState(null);
    const [valueCoin, setValueCoin] = useState("0");

    useEffect(() => {
        setToken(route.params.token);
        setQtd(JSON.stringify(route.params.qtd));
    }, []);

    return (
        <>
            <HeaderDefault title={<FormattedMessage id= "buyexchange.exchangeTitulo" />} />

            <View style={styles.content}>
                <View style={styles.token_header_container}>
                    {token && <Image source={{ uri: `https://filesgpx.s3.us-east-2.amazonaws.com/${token.path}` }} style={styles.token_header_image} />}
                    <Text style={styles.token_header_title}>{token ? token.name_token : <FormattedMessage id= "buyexchange.gpx" />}</Text>
                </View>
                <View style={styles.contentAmount}>
                    <Text style={styles.titlePage}>
                    <FormattedMessage id= "buyexchange.definirQuantidade" />
                        </Text>
                    <TextInput style={styles.textInputAmount} value={qtd} onChangeText={(e) => setQtd(e.toString())} keyboardType="numeric" />
                </View>

                <View style={styles.contentAmount}>
                    <Text style={styles.titlePage}>
                    <FormattedMessage id= "buyexchange.definirprecoCompra" />
                    </Text>
                    <TextInput style={styles.textInputAmount} value={valueCoin} onChangeText={(e) => setValueCoin(e.toString())} keyboardType="numeric" />
                </View>

                <View style={styles.contentPrices}>
                    <Text style={styles.descriptionPrice}> 
                    <FormattedMessage id= "buyexchange.ultimoPreco" />
                    </Text>
                    <Text style={styles.price}>
                    <FormattedMessage id= "buyexchange.000.000Gpx" />
                    </Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.descriptionPrice}>
                        <FormattedMessage id= "buyexchange.precoVenda" />
                    </Text>
                    <Text style={styles.price}>{token ? token.single_value : "000.000,00"}
                    <FormattedMessage id= "buyexchange.gpx" />
                    </Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.descriptionPrice}>
                    <FormattedMessage id= "buyexchange.precoMercado" />
                    </Text>
                    <Text style={styles.price}>
                    <FormattedMessage id= "buyexchange.000.000Gpx" />
                    </Text>
                </View>
            </View>

            <View style={styles.contentCheckbox}>
                <Checkbox
                    status={checked ? 'checked' : 'indeterminate'}
                    onPress={() => {
                        setChecked(!checked);

                    }}
                />
                <Text>
                <FormattedMessage id= "buyexchange.comprarPrecoMercado" />
                </Text>
            </View>

            <View style={styles.contentBtn}>
                <TouchableOpacity onPress={() => navigation.navigate('ConfirmPassword', { qtd: qtd, valueCoin: valueCoin, market: checked, purchase: true })}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#196059", "#196059"]}
                        style={styles.btn}
                    >
                        <Text style={styles.textBtn}>
                        <FormattedMessage id= "buyexchange.continuar" />
                        </Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>
        </>
    );
}

export default BuyExchange;